import i18n from 'i18next'
import '../../i18n/config'

const {t} = i18n

export function getPaginationConfig(pageIndex, pageSize, itemCount, onPageChangeFunc) {
  return {
    current: pageIndex,
    pageSize,
    total: itemCount,
    pageSizeOptions: ['10', '20', '50', '100'],
    onChange: onPageChangeFunc,
    showTotal: e => `${t(`general.totalOf`)} ${e} ${t(`general.data`)}`,
    style: {marginRight: '6px'},
    showSizeChanger: true,
    showQuickJumper: true,
    onShowSizeChange: onPageChangeFunc,
  }
}
